var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ur-modal',{ref:"modal",attrs:{"draggable":""},on:{"closed":_vm.closedModel}},[_c('span',[_vm._v("You are Logged out!!!")]),_c('template',{slot:"action"},[_c('ur-button',{attrs:{"main":""},on:{"click":_vm.onClickOK}},[_vm._v("Okay")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }